import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

import { Size }                 from '@src/types';
import { BasicDialogContainer } from '@src/views/components/modals/BasicDialogContainer';
import { SurveyBuilderSection } from '@src/views/pages/projects/operations/SurveyBuilderSection';


interface SurveyBuilderDialogProps {
    onClose: () => void;
}

function SurveyBuilderDialog( { onClose }: SurveyBuilderDialogProps ){

    return (
        <>
            <BasicDialogContainer
                title={ 'Survey Builder' }
                contentMinHeight={ `70dvh` }
                contentMaxHeight={ `70dvh` }
                contentPadding={ [ Size.MD, Size.MD, Size.MD, Size.MD ] }
                containerStyles={ { position: 'absolute', inset: `20px 20px 60px 20px` } }
                overflow={ true }
                scrolling={ false }
                roundedTop={ true }>

                <SurveyBuilderSection/>

            </BasicDialogContainer>

            <Modal.Actions style={ { textAlign: 'center' } }>
                <Button basic onClick={ onClose }>Close</Button>
            </Modal.Actions>
        </>
    );
}


export {
    SurveyBuilderDialog,
    type SurveyBuilderDialogProps,
};
